import React from 'react';
import { Section } from './ui/Section';
export function TomosDetail() {
  const tomos = [{
    icon: '📘',
    title: 'TOMO 1 — ARQUITECTURA DEL DESBLOQUEO',
    desc: 'Entiende por qué tu cerebro no para. Test de Saturación Crítica™ + Mapa de Nodos Mentales™ + el parche de seguridad emocional que nadie te enseñó.'
  }, {
    icon: '📗',
    title: 'TOMO 2 — PROTOCOLO DE VACIADO 10X',
    desc: 'El sistema técnico para hacer el Hard-Reset diario en menos de 10 minutos. Vaciado de Cascada™ + Filtro de Única Decisión + Almacenamiento Seguro. Para no llevarte el trabajo a la cama nunca más.'
  }, {
    icon: '📙',
    title: 'TOMO 3 — INGENIERÍA DE LA ATENCIÓN',
    desc: 'Blindaje total contra el secuestro digital. Recupera el enfoque profundo y construye bloques de trabajo sin interrupciones ni culpa.'
  }, {
    icon: '📕',
    title: 'TOMO 4 — REINICIO MAESTRO',
    desc: 'Cómo mantener el sistema limpio a largo plazo. Rituales de cierre semanal + protocolo de revisión mensual + plan de sostenibilidad mental.'
  }];
  const features = ['Protocolo 100% listo — abrís el PDF y arrancás hoy', 'Ejercicios de implementación inmediata', 'Hojas de trabajo descargables', 'Diseñado para personas que no tienen tiempo de meditar', 'Compatible con móvil, tablet y ordenador'];
  return <Section data-id="element-203">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-204">
        💪 4 TOMOS COMPLETOS
      </h2>

      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-205">
        {tomos.map((tomo, i) => <div key={i} className="bg-brand-card border border-neutral-800 rounded-2xl p-8 hover:bg-neutral-900 transition-colors" data-id="element-206">
            <div className="text-4xl mb-4" data-id="element-207">{tomo.icon}</div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-208">{tomo.title}</h3>
            <p className="text-neutral-400 leading-relaxed" data-id="element-209">{tomo.desc}</p>
          </div>)}
      </div>

      <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8 max-w-2xl mx-auto" data-id="element-210">
        <h4 className="text-lg font-bold mb-6 text-center" data-id="element-211">
          Cada tomo incluye:
        </h4>
        <ul className="space-y-4" data-id="element-212">
          {features.map((feat, i) => <li key={i} className="flex items-start gap-3" data-id="element-213">
              <span className="text-green-500 shrink-0" data-id="element-214">✅</span>
              <span className="text-neutral-300" data-id="element-215">{feat}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
}